<app-payroll-run-selection
  title="Loonjournaal voor grootboeksysteem - Loonjournaal selecteren"
  actionLabel="Maak journalisering"
  [showFooterAction]="false"
  [initialOpdrachtgeverId]="initialOpdrachtgeverId"
  [initialInstellingId]="initialInstellingId"
  (action)="onCreate($event)"
  (downloadList)="onDownloadList($event)"
/>
